import {
    deleteErrorMessage,
    handleDragAndDrop,
    isUserAnswerInputChecked,
    setItemsHeight, showErrorMessage
} from "../../../assessments/CreateAssessmentHelpers";
import l10n from "../../../lang/locallang";
export default class AssessmentMatchingPublic {
    view(data, popup) {
        let itemsResult = ``;
        let itemsChoice = ``;
        let itemsMatch = ``;
        if(data.content){
            //list.sort(() => Math.random() - 0.5);
            let matchID = '';
            for (const [key, value] of Object.entries(data.content)) {
                const randomNumber = Math.floor(Math.random() * 1000);
                matchID = btoa(`${randomNumber} ${value.id} match`);
                itemsMatch += `<li data-matching-id="${matchID}" class="matching__answers-item">
                    <p class="matching__answers-item-text">${value.value.match}</p>
                </li>`;
            }
            data.content.sort(() => Math.random() - 0.5);
            let choiceID = '';
            for (const [key, value] of Object.entries(data.content)) {
                const randomNumber = Math.floor(Math.random() * 1000);
                choiceID = btoa(`${randomNumber} ${value.id} choice`);
                itemsChoice += `<li data-matching-id="${choiceID}" class="matching__questions-item" draggable="true">
                    <p class="matching__questions-item-text">${value.value.choice}</p>
                </li>`;
            }
        } else {
            return '';
        }

        return `<div class="matching not-submitted">
                    <ul class="matching__questions">
                        ${itemsChoice}
                    </ul>

                    <ul class="matching__answers">
                        ${itemsMatch}
                    </ul>
            </div>`;
    }

    checkError() {
        let result = true;
        let popup = document.querySelector('#take-assessment-popup');
        const elements_count = popup.querySelectorAll('.matching__answers-item, .matching__questions-item').length;
        const elements_dragged = popup.querySelectorAll('.matching__questions-item.is-dragged-right').length;
        const { errorMessage } = l10n.assessmentMatching;

        // if exists error message remove it
        deleteErrorMessage(popup);

        if(elements_dragged !== elements_count/2){
            // upper .popup-body add error message
            showErrorMessage(popup, errorMessage);
            result = false;
        } else {
            result = true;
        }
        return result;
    }

    addAnswersList(popup) {
        let answers = [];
        let matchingQuestions = popup.querySelectorAll('.matching__questions-item');
        let matchingAnswers = popup.querySelectorAll('.matching__answers-item');
        // add to data array matching questions and answers
        matchingQuestions.forEach(function (item, index) {
            answers[index] = item.querySelector('.matching__questions-item-text').textContent;
        });
        matchingAnswers.forEach(function (item, index) {
            answers[index] = answers[index] + ' - ' + item.querySelector('.matching__answers-item-text').textContent;
        });
        console.log(answers)
        return answers;
    }

    showResult(data){
        console.log(data)
        const { correctStatus, wrongStatus, correctMatching } = l10n.customCourse;
        let popup = document.querySelector('#take-assessment-popup');
        if (!popup) return;
        const assessHint = popup.querySelector('.cg-popup__assess-hint') || popup.querySelector('.assessment-popup-header');

        if (assessHint) {
            assessHint.innerHTML = correctMatching;
        }

        const matchingBlock = popup.querySelector('.matching') || popup.querySelector('.quiz-matching');
        if (matchingBlock) {
            matchingBlock.classList.remove('not-submitted');
        }
        popup.classList.remove('is-incorrect', 'is-correct');
        if(data.status) {
            popup.classList.add('is-correct');
            const resultEl = popup.querySelector('.cg-popup__result') || popup.querySelector('.assessment-result');
            if (resultEl) {
                resultEl.innerHTML = `
                    <i class="cg-popup__status-icon"></i>
                    <p class="cg-popup__status-label">${correctStatus}</p>
                `;
            }
        } else {
            popup.classList.add('is-incorrect');
            const resultEl = popup.querySelector('.cg-popup__result') || popup.querySelector('.assessment-result');
            if (resultEl) {
                resultEl.innerHTML = `
                    <i class="cg-popup__status-icon"></i>
                    <p class="cg-popup__status-label">${wrongStatus}</p>
                `;
            }
        }

        // add .matching-result_item class depends on true or false on data.message object
        console.log(data.correctList)
        const matchingItems = popup.querySelectorAll('.matching__questions-item');
        if (matchingItems && matchingItems.length) {
            data.correctList.forEach(function (item, index) {
                const element = matchingItems[index];
                if (element && element.querySelector('.matching__questions-item-text')) {
                    element.querySelector('.matching__questions-item-text').textContent = item;
                }
            });
        }

        // set class .undragable to all matching-item
        matchingItems.forEach(function (item) {
            item.classList.add('undragable');
        });
    }
}
